import { Route } from '@/types'

export const testroute: Route = {
  id: 'testroute',
  label: 'Testroute',
  duration: '10 minuten',
  center: {
    lon: 3.716293314,
    lat: 51.040218311
  },
  steps: [
    {
      label: 'Start',
      component: 'Steen',
      coordinates: {
        lon: 3.716293314,
        lat: 51.040218311
      },
      instruction:
        'Start aan Baliestraat 11. Wandel richting de eerste tussenstop.',
      type: 'game'
    },
    {
      label: 'Tussenstop 1',
      coordinates: {
        lon: 3.715252617,
        lat: 51.040265533
      },
      instruction: 'Wandel verder naar tussenstop 2.',
      type: 'info'
    },
    {
      label: 'Tussenstop 2',
      coordinates: {
        lon: 3.71400539,
        lat: 51.040322874
      },
      instruction: 'Ga naar tussenstop 3.',
      type: 'info'
    },
    {
      label: 'Tussenstop 3',
      coordinates: {
        lon: 3.712707201,
        lat: 51.03993835
      },
      instruction: 'Ga verder.',
      type: 'info'
    },
    {
      label: 'Tussenstop 4',
      coordinates: {
        lon: 3.713297287,
        lat: 51.039479616
      },
      instruction: 'Goed bezig, wandel verder richting het eindpunt.',
      type: 'info'
    },
    {
      label: 'Tussenstop 5',
      coordinates: {
        lon: 3.714584747,
        lat: 51.039557196
      },
      instruction: 'Bijna.',
      type: 'info'
    },
    {
      label: 'Eindpunt',
      coordinates: {
        lon: 3.715459147,
        lat: 51.039796683
      },
      instruction: 'Je bent aangekomen.',
      type: 'info'
    }
  ],
  geometry: {
    coordinates: [
      [3.716295, 51.040239],
      [3.715571, 51.040263],
      [3.715483, 51.040281],
      [3.715255, 51.040288],
      [3.714368, 51.040316],
      [3.714207, 51.040311],
      [3.714219, 51.040301],
      [3.714004, 51.040308],
      [3.7136, 51.040321],
      [3.713567, 51.040344],
      [3.713467, 51.040301],
      [3.713402, 51.040284],
      [3.713391, 51.040264],
      [3.712697, 51.039946],
      [3.712361, 51.039792],
      [3.713027, 51.039542],
      [3.713291, 51.039472],
      [3.713746, 51.039351],
      [3.713857, 51.039408],
      [3.714286, 51.03951],
      [3.714574, 51.039575],
      [3.714872, 51.039643],
      [3.715463, 51.039791]
    ],
    type: 'LineString'
  }
}
